export const routerLocale = false;

export const getRouterLocale = (router) => {
  return false;
  return router.locale || router.defaultLocale;
};
